import walidacjaRoku from '@components/form/validation/field/rokProdukcji'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Rok produkcji',
    name: 'rok-produkcji',
    type: 'number',

}, walidacjaRoku)